import React from 'react';
import ExistingIntegrations from '@components/service-integrations/existing-integrations';
import AvailableIntegrations from '@components/service-integrations/available-integrations';
import { ContentWrapper } from '../styled';

function MainView() {
  return (
    <ContentWrapper>
      <ExistingIntegrations />
      <AvailableIntegrations />
    </ContentWrapper>
  );
}

export default MainView;
